import React, { FC } from "react";

import { Stack } from "react-bootstrap";

import classNames from "classnames";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { ROUTES } from "src/routes";

import { RssDocument } from "@api/graphql";
import { DrawerUploadIcon } from "@assets/icons";

import styles from "./index.module.scss";

interface UploadButtonProps {
  sourceRecord: RssDocument;
}

export const UploadButton: FC<UploadButtonProps> = ({ sourceRecord }) => {
  return (
    <div className={classNames(styles["td-container"], "justify-content-center")}>
      <Stack direction="horizontal" gap={2}>
        <ReactSVG className={classNames(styles["upload-icon"])} src={DrawerUploadIcon} />
        <Link to={ROUTES.ResaleCsvSubmission.path} state={{ sourceFile: sourceRecord }} className="b3 bold">
          Start Upload
        </Link>
      </Stack>
    </div>
  );
};
